var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M9 7l2 0 18 17 -18 23 -2 0 0 -40zm165 27l10 13 -10 0 0 -13zm-155 13l11 -13 0 13 -11 0zm17 0l0 -23c0,0 0,0 0,-1 0,0 0,0 0,0 0,0 0,0 0,-1 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,-1 -1,-1l-14 -14 161 0 -14 14c0,0 0,1 0,1 -1,0 -1,0 -1,0 0,0 0,0 0,0 0,1 0,1 0,1 0,0 0,0 0,0 0,1 0,1 0,1l0 23 -131 0zm156 0l-17 -23 17 -17 2 0 0 40 -2 0zm5 46l0 67 0 19 0 17 -191 0 0 -142 191 0 0 25 0 14zm7 67l0 -68 0 -11 0 -34 -3 0 0 -47 -198 0 0 47 -4 0 0 156 205 0 0 -24 0 -19zm-75 -99c-8,0 -14,6 -14,14 0,1 2,3 4,3 1,0 3,-2 3,-3 0,-4 3,-7 7,-7 3,0 6,3 6,7 0,1 2,3 4,3 2,0 3,-2 3,-3 0,-8 -6,-14 -13,-14zm0 10c-2,0 -4,2 -4,4l0 20c0,13 -10,24 -23,24 -13,0 -24,-11 -24,-24l0 -20c0,-2 -2,-4 -3,-4 -2,0 -4,2 -4,4l0 20c0,17 14,30 31,30 16,0 30,-13 30,-30l0 -20c0,-2 -1,-4 -3,-4zm-48 4c0,1 2,3 4,3 2,0 3,-2 3,-3 0,-8 -6,-14 -13,-14 -8,0 -14,6 -14,14 0,1 1,3 3,3 2,0 4,-2 4,-3 0,-4 3,-7 7,-7 3,0 6,3 6,7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProducts);
export default __webpack_public_path__ + "static/media/AddProducts.2ea158bd4bbf516ab21b398b09e4ab8c.svg";
export { ForwardRef as ReactComponent };